import React, { createContext, useContext, useState } from "react";

const SearchContext = createContext();

export const useSearch = () => useContext(SearchContext);

export const SearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResult, setSearchResult] = useState([]);

  return (
    <SearchContext.Provider
      value={{ searchTerm, setSearchTerm, searchResult, setSearchResult }}
    >
      {children}
    </SearchContext.Provider>
  );
};
